import axios from 'axios'

export default {
  state: {
    token: null,
    refresh_token: null
  },
  getters: {
    id_token: state => {
      return state.token.id_token
    },
    idTokenData: state => {
      if (state.token.id_token) {
        return JSON.parse(Buffer.from(state.token.id_token.split('.')[1], 'base64'))
      }
    },
    authenticated: state => {
      return !!state.token
    },
    refreshToken: state => {
      return state.refresh_token
    }
  },
  mutations: {
    SET_TOKEN (state, token) {
      state.token = token
    },
    SET_REFRESH_TOKEN (state, refreshToken) {
      state.refresh_token = refreshToken
    },
    CLEAR_TOKENS (state) {
      state.token = null
      state.refresh_token = null
    }
  },
  actions: {
    SET_TOKEN ({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    SET_REFRESH_TOKEN ({ commit }, refreshToken) {
      commit('SET_REFRESH_TOKEN', refreshToken)
    },
    CLEAR_TOKENS ({ commit }) {
      commit('CLEAR_TOKENS')
    },
    GET_TOKENS ({ commit }, code) {
      return axios.post(
        process.env.AUTH_ENDPOINT + '/oauth2/token', {}, {
          params: {
            grant_type: 'authorization_code',
            client_id: process.env.COGNITO_APP_CLIENT_ID,
            redirect_uri: `${process.env.PORTAL_ENDPOINT}/login`,
            code: code
          },
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        .then(response => {
          commit('SET_TOKEN', response.data)
          commit('SET_REFRESH_TOKEN', response.data.refresh_token)
        })
        .catch((error) => {
          console.log(`failed to get oauth token : ${error.message}`)
        })
    },
    REFRESH_TOKEN ({ commit }, refreshToken) {
      return axios.post(
        process.env.AUTH_ENDPOINT + '/oauth2/token', {}, {
          params: {
            grant_type: 'refresh_token',
            client_id: process.env.COGNITO_APP_CLIENT_ID,
            refresh_token: refreshToken
          },
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        .then(response => {
          commit('SET_TOKEN', response.data)
        })
        .catch(error => {
          console.log(`failed to refresh token : ${error.message}`)
        })
    },
    REVOKE_TOKEN ({ commit }, refreshToken) {
      return axios.post(
        process.env.AUTH_ENDPOINT + '/oauth2/revoke', {}, {
          params: {
            client_id: process.env.COGNITO_APP_CLIENT_ID,
            token: refreshToken
          },
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        .catch((error) => {
          console.log(`failed to revoke token : ${error.message}`)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/index.js